import { Box, FormLabel, MenuProps as MenuPropsType } from '@mui/material';
import pallet from '../../../layouts/pallet';
import { makeStyles } from '@mui/styles';
import styled from 'styled-components';

export const useStyles = makeStyles(() => ({
  selectedAll: {},
  indeterminateColor: {
    color: pallet.primary
  },
  selectAllText: {
    fontWeight: 600
  }
}));

export const MenuProps: Partial<MenuPropsType> = {
  style: {
    zIndex: 9999
  },
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250
    }
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  sx: {
    zIndex: '10000',
    slotProps: {
      backdrop: {
        sx: {
          backgroundColor: 'transparent !important'
        }
      }
    }
  }
};

export const SelectedItemChip = styled(Box)(() => ({
  display: 'flex',
  backgroundColor: pallet.lightGrey2,
  paddingInline: 4,
  borderRadius: 8
}));

export const FormInputLabel = styled(FormLabel).attrs({
  as: 'h6'
})(() => ({
  margin: 0,
  color: pallet.formLabelText,
  fontSize: 13,
  fontWeight: 500,
  marginBottom: '6px'
}));
